import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import NavButton from './NavButton';
import UserNavMenu from './UserNavMenu';

const desktopStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexGrow: 1,
  },
}));

const DesktopMenu = ({toggleServicesMenu, showServicesMenu, toggleAuthMenu}) => {
  const classes = desktopStyles();
  return (
    <div className={classes.root}>
      <div>
        <NavButton
          id="nav-services-button"
          variant="text"
          color="primary"
          onClick={toggleServicesMenu}
        >
          Services
          {showServicesMenu ? (<KeyboardArrowUpIcon />) : (<KeyboardArrowDownIcon />)}
        </NavButton>
        <NavButton to='/about'>About us</NavButton>
        <NavButton to='/blog'>Blog</NavButton>
        <NavButton to='/providers'>For Providers</NavButton>
      </div>
      <div>
        <UserNavMenu toggleAuthMenu={toggleAuthMenu}/>
      </div>
    </div>
  );
};

DesktopMenu.propTypes = {
  showServicesMenu: PropTypes.bool.isRequired,
  toggleServicesMenu: PropTypes.func.isRequired,
  toggleAuthMenu: PropTypes.func.isRequired,
};

const mobileStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexGrow: 1,
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  icon: {
    color: theme.palette.primary.main,
  },
}));

const MobileMenu = ({toggleMobileMenu}) => {
  const classes = mobileStyles();
  return (
    <div className={classes.root}>
      <IconButton
        edge="start"
        className={classes.NavButton}
        color="inherit"
        aria-label="open drawer"
        onClick={toggleMobileMenu}
      >
        <MenuIcon className={classes.icon}/>
      </IconButton>
    </div>
  );
};

MobileMenu.propTypes = {
  toggleMobileMenu: PropTypes.func.isRequired,
};

const MenuControls = ({showServicesMenu, toggleServicesMenu, toggleMobileMenu, toggleAuthMenu}) => {
  return (
    <React.Fragment>
      <DesktopMenu
        showServicesMenu={showServicesMenu}
        toggleServicesMenu={toggleServicesMenu}
        toggleAuthMenu={toggleAuthMenu}
      />
      <MobileMenu toggleMobileMenu={toggleMobileMenu} />
    </React.Fragment>
  );
};

MenuControls.propTypes = {
  showServicesMenu: PropTypes.bool.isRequired,
  toggleServicesMenu: PropTypes.func.isRequired,
  toggleMobileMenu: PropTypes.func.isRequired,
  toggleAuthMenu: PropTypes.func.isRequired,
  servicesButtonRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
};

export default MenuControls;
